import { Tabs } from "devextreme-react";
import { useState } from "react";
import ConfigureMappingData from "../../../common/ConfigureMappingData";
import ConfigureSafetyReporting from "./ConfigureSafetyReporting";

export default function Configuration() {
  const [configType, setConfigType] = useState("IRBSubmission");
  const [dataSource, setDataSource] = useState([
    {
      text: "IRB Submission",
      type: "IRBSubmission",
    },
    {
      text: "Site Visits",
      type: "siteVisits",
    },
    {
      text: "Visit Report",
      type: "visitReport",
    },
    {
      text: "Safety Reporting",
      type: "safetyReporting",
    },
  ]);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setConfigType(e.itemData.type);
  };

  return (
    <>
      <Tabs
        dataSource={dataSource}
        defaultSelectedIndex={0}
        height={40}
        itemRender={itemRender}
        onItemClick={onItemClick}
      />
      {configType == "IRBSubmission" && (
        <div>
          <div style={{ margin: "16px 0px" }} />
          <ConfigureMappingData
            cat={"13"}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "IRB Submission",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name={"IRB Submission"}
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </div>
      )}
      {configType == "siteVisits" && (
        <div>
          <div style={{ margin: "16px 0px" }} />
          <ConfigureMappingData
            cat={13}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Site Visits",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name={"Site Visits"}
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </div>
      )}
      {configType == "visitReport" && (
        <div>
          <div style={{ margin: "16px 0px" }} />
          <ConfigureMappingData
            cat={13}
            colorEnabled={false}
            configColumnData={{
              alignment: "center",
              caption: "Visit Report",
              dataField: "name",
              isNumber: false,
              width: 150,
            }}
            name={"Visit Report"}
            sortOrderEnabled={false}
            sumFieldEnabled={false}
            issRelEnabled={false}
          />
        </div>
      )}
      {configType == "safetyReporting" && (
        <div>
          <div style={{ margin: "16px 0px" }} />
          <ConfigureSafetyReporting />
        </div>
      )}
    </>
  );
}
